'use client';

import { Container } from 'components/gruenland/atoms/container/Container';
import OrderLoader from '../public-order/components/OrderLoader';
import OrderNotFound from '../public-order/components/OrderNotFound';
import usePublicOrder from '../public-order/hooks/usePublicOrder';
import ReturnsPage from './components/ReturnsPage';

type Props = {
  search: {
    email?: string;
    order?: string;
  };
};

const Returns: React.FC<Props> = ({ search }) => {
  const { order, loading, loaded } = usePublicOrder(search);
  const hasParams = !!(search.email && search.order);

  // If order is loaded, show it with a button to search for another order
  if (order) {
    return (
      <Container>
        <ReturnsPage order={order} />
      </Container>
    );
  }

  return (
    <Container>
      {hasParams && loading && <OrderLoader />}
      {hasParams && !loading && loaded && !order && <OrderNotFound />}
    </Container>
  );
};

export default Returns;
